export enum AnnuityGuaranteeTypeIdEnum {
  ZeroYear = 1,
  FiveYear = 2,
  TenYear = 3,
  FifteenYear = 4,
  TwentyYear = 5
}
